import { api,api_formdata } from './_request';

 export const get = () => {
 	return (dispatch) => {

 		api().get('/inventario').then(function(response) {
			if(response.status === 200) {
				dispatch({
				type: 'CLIENTE_LIST',
					payload: response.data
 				});
			}
 		});

 	}
 };

 



export const update = (usuario,id, callback) => {
	return (dispatch) => {

        
		dispatch({ type: 'CLIENTE_SAVE' });

		api_formdata().post(`inventario/${id}`, usuario)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'CLIENTE_UPDATE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback();
			}
			else
			{
				dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'PROSPECT_SAVE_FAILURE' });
		});

	}
};

export const save = (item,id, callback) => {
	return (dispatch) => {

		dispatch({ type: 'CLIENTE_SAVE' });

		api_formdata().post('inventario', item ).then(function(response) {

			if(response.status === 200) {

                console.log( response.data);
				dispatch({
					type: 'CLIENTE_SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'CLIENTE_SAVE_FAILURE' });
		});

	}
};

export const alerta = (alerta) => {
		return (dispatch) => {
			dispatch({
						type: 'SAVE_ALERTA',
						payload: alerta
					});
		}
	};


// WEBPACK FOOTER //
// ./src/actions/inventario.js